/* global jQuery, themeVariables */
import jQuery from 'jquery';

// Relative Imports
import Header from './modules/header';
import Filters from './modules/filters';
import HighlightToTweet from './modules/highlight-to-tweet';
import SocialSharing from './modules/social-sharing';
import ExpandTerms from "./modules/expanded-terms";
import ExpandedText from "./modules/expanded-text";
import LanguageSwitch from './modules/language-switch';
import LightboxGallery from './modules/lightbox-gallery';
import TableOfContents from "./modules/table-of-contents";

(function ($) {
    const debug = true;
    const mobileBreakpoint = 1024;

    // In functions-config.php we are passing `themeVariables` to push PHP
    // values to JS console.log(themeVariables);

    /**
     * Table of Contents
     */
    new TableOfContents();

    /**
     * Header
     */
    new Header(mobileBreakpoint);

    /**
     * Filters
     */
    new Filters('.js-filters');

    /**
     * Terms expanding.
     */
    new ExpandTerms();

    /**
     * Expand text component
     */
    new ExpandedText();

    /**
     * Language switcher
     */
    new LanguageSwitch();

    /**
     * Lightbox gallery
     */
    new LightboxGallery();

    /**
     * Social sharing
     */
    new SocialSharing('.js-social-share', '.js-webshare');
}(jQuery));
